import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-secondary mt-2 small" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "d-flex justify-content-end mt-4 pt-3 border-top" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

import { computed, ref } from 'vue';
import {
  BAlert,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BModal,
  BSpinner,
} from 'bootstrap-vue-next';
import { useMutation } from '@vue/apollo-composable';
import { InviteCreateDocument, OrganizationType } from '@/gql/graphql';
import {
  OrganizationMembershipModeSelectOptions,
  OrganizationUserRoleSelectOptions,
  ORGANIZATION_USER_ROLES,
} from '@/constants';

// --- Props for the component ---
interface Props {
  organization: OrganizationType;
  show: boolean;
  adminView?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'InviteCreate',
  props: {
    organization: {},
    show: { type: Boolean },
    adminView: { type: Boolean }
  },
  emits: ['success', 'close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

// --- Computed Properties ---
const show = computed<boolean>(() => {
  return props.show;
});

// --- Data for new member invitation ---
const email = ref('');
const role = ref<string>(ORGANIZATION_USER_ROLES.MEMBER);
const message = ref('');
const description = ref('');

// --- Mutation: Switch Active Organization ---
const mutationInProgress = ref(false);
const mutationShowSuccess = ref(false);
const mutationError = ref<string | null>(null);

const {
  mutate: inviteCreateMut,
  onDone: onInviteCreateDone,
  onError: onInviteCreateError,
} = useMutation(InviteCreateDocument);

onInviteCreateDone((res) => {
  mutationInProgress.value = false;
  if (res.data && res.data.inviteCreate) {
    console.debug('Invite created:', res.data.inviteCreate);
    mutationShowSuccess.value = true;

    email.value = '';
    role.value = ORGANIZATION_USER_ROLES.MEMBER;
    message.value = '';
    description.value = '';

    emits('success', res.data.inviteCreate);

    setTimeout(() => {
      mutationShowSuccess.value = false;
      handleCloseModal();
    }, 1500);
  } else {
    console.error('Invitation failed:', res.data);
    mutationError.value = 'Invitation failed: ' + res.data;
  }
});

onInviteCreateError((err) => {
  console.error('Error creating invite:', err);
  mutationInProgress.value = false;
  mutationError.value = err.message;
});

// --- Handlers
function createInvite() {
  // Invite new user to organization
  mutationInProgress.value = true;
  mutationError.value = null;

  // Validate
  if (!props.organization?.id) {
    console.error('No organization to invite user to');
    mutationInProgress.value = false;
    mutationError.value = 'No organization to invite user to';
    return;
  }

  // Execute mutation
  console.log('Inviting user to organization:', props.organization.id);
  inviteCreateMut({
    invitedEmail: email.value,
    invitedOrganizationId: props.organization.id,
    invitedOrganizationUserRole: role.value,
    message: message.value,
    description: description.value,
  });
}

function handleCloseModal() {
  emits('close');
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (props.organization)
    ? (_openBlock(), _createBlock(_unref(BModal), {
        key: 0,
        class: "orgActivateModal",
        modelValue: show.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((show).value = $event)),
        onHide: handleCloseModal,
        "hide-footer": ""
      }, {
        title: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'user-plus'],
            class: "me-2"
          }),
          _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Invite New User", -1))
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_unref(BForm), {
              onSubmit: _withModifiers(createInvite, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, [
                  _cache[7] || (_cache[7] = _createTextVNode(" Invite a new user to join ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(props.organization.name), 1),
                  _cache[8] || (_cache[8] = _createTextVNode(" organization. The invited user will receive an email with instructions to accept the invitation and join the organization. You can assign them a role of Member, Admin, or Owner to control their level of access and permissions within the organization. ", -1))
                ]),
                _createVNode(_unref(BFormGroup), null, {
                  default: _withCtx(() => [
                    _cache[9] || (_cache[9] = _createElementVNode("label", {
                      for: "email-input",
                      class: "form-label"
                    }, "User Email", -1)),
                    _createVNode(_unref(BFormInput), {
                      id: "email-input",
                      modelValue: email.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                      type: "email",
                      required: "",
                      placeholder: "user@example.com"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(BFormGroup), { class: "mt-3" }, {
                  default: _withCtx(() => [
                    _cache[15] || (_cache[15] = _createElementVNode("label", {
                      for: "role-select",
                      class: "form-label"
                    }, "Role", -1)),
                    _createVNode(_unref(BFormSelect), {
                      id: "role-select",
                      modelValue: role.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((role).value = $event)),
                      options: 
              props.adminView
                ? _unref(OrganizationUserRoleSelectOptions)
                : _unref(OrganizationMembershipModeSelectOptions)
            
                    }, null, 8, ["modelValue", "options"]),
                    _createElementVNode("p", _hoisted_1, [
                      _cache[11] || (_cache[11] = _createElementVNode("strong", null, "Members", -1)),
                      _cache[12] || (_cache[12] = _createTextVNode(" can view and use resources but cannot manage organization members or settings. ", -1)),
                      _cache[13] || (_cache[13] = _createElementVNode("strong", null, "Admins", -1)),
                      _cache[14] || (_cache[14] = _createTextVNode(" can manage organization members and settings. ", -1)),
                      (props.adminView)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [...(_cache[10] || (_cache[10] = [
                            _createElementVNode("strong", null, "Owners", -1),
                            _createTextVNode(" have full control over the organization, including managing members, settings, and resources. Owners cannot be removed by admins. Only one owner is allowed per organization. ", -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(BFormGroup), { class: "mt-1" }, {
                  default: _withCtx(() => [
                    _cache[16] || (_cache[16] = _createElementVNode("label", {
                      for: "message-textarea",
                      class: "form-label"
                    }, "Message", -1)),
                    _createVNode(_unref(BFormTextarea), {
                      id: "message-textarea",
                      modelValue: message.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((message).value = $event)),
                      placeholder: "Add an optional personal message that will be attached to the invitation email.",
                      rows: "3"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(BFormGroup), { class: "mt-3" }, {
                  default: _withCtx(() => [
                    _cache[17] || (_cache[17] = _createElementVNode("label", {
                      for: "description-textarea",
                      class: "form-label"
                    }, "Description", -1)),
                    _createVNode(_unref(BFormTextarea), {
                      id: "description-textarea",
                      modelValue: description.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((description).value = $event)),
                      placeholder: "Add an optional description or note about this invitation for internal use.",
                      rows: "3",
                      maxlength: "255"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(BAlert), {
                  modelValue: mutationError.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((mutationError).value = $event)),
                  variant: "danger",
                  dismissible: "",
                  class: "mt-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(mutationError.value), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(BButton), {
                    variant: "secondary",
                    onClick: handleCloseModal,
                    class: "me-2"
                  }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("span", null, "Cancel", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_unref(BButton), {
                    type: "submit",
                    variant: "primary",
                    disabled: mutationInProgress.value || mutationShowSuccess.value
                  }, {
                    default: _withCtx(() => [
                      (mutationInProgress.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                            _createVNode(_unref(BSpinner), {
                              small: "",
                              label: "",
                              class: "me-1"
                            }),
                            _cache[19] || (_cache[19] = _createTextVNode(" Inviting member ", -1))
                          ]))
                        : (mutationShowSuccess.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fas', 'check-double'],
                                class: "me-1"
                              }),
                              _cache[20] || (_cache[20] = _createTextVNode(" Member invited ", -1))
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fas', 'user-plus'],
                                class: "me-1"
                              }),
                              _cache[21] || (_cache[21] = _createTextVNode(" Invite new user ", -1))
                            ]))
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})